import React, { useEffect, useState } from "react";
import TextInputField from "../Shared/TextInputField";
import Textarea from "../Shared/Textarea";
import Button from "../Shared/Button";
import { ivrService } from "../../services/voice";
import firebase from "../../services/firebase";
import { isEmpty } from "lodash";

import { displayTimestamp } from "../../utils/dateDisplay";
const VOICE_CONTENT = `(pause 2) Hi Michael. This is Tele-care (pause 1). Your GP has referred you to see our tele-health specialist on Friday fourth December three thirty P M (pause 1). Please press one to confirm, (pause 1) 2 to cancel (pause 1) and 3 to speak to an operator.`;

const InteractiveVoiceResponse = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [voiceContent, setVoiceContent] = useState(VOICE_CONTENT);
  const [isCalling, setIsCalling] = useState(false);
  const [logs, setLogs] = useState([]);

  const onClickCall = async () => {
    setIsCalling(true);
    await ivrService(phoneNumber, voiceContent);
    setIsCalling(false);
  };

  useEffect(() => {
    const ref = firebase.database().ref();
    ref.child("ivr").on("value", (snapshot) => {
      const logsSnapshot = snapshot.val();
      if (logsSnapshot) {
        setLogs(Object.values(logsSnapshot));
      }
    });
    return () => {
      ref.off();
    };
  }, [setLogs]);

  return (
    <div className="columns">
      <div className="column is-half">
        <TextInputField
          label="Phone number"
          value={phoneNumber}
          placeholder="e.g 0411747557"
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
        <Textarea
          label="Voice Content"
          value={voiceContent}
          onChange={(e) => setVoiceContent(e.target.value)}
          disabled={true}
        />
        <Button
          text="Call"
          onClick={onClickCall}
          isLoading={isCalling}
          disabled={isEmpty(phoneNumber) || isEmpty(voiceContent)}
        />
        <div className="is-size-7 py-1">
          {logs.map((log, idx) => (
            <div key={idx}>{`${displayTimestamp(log.ts)}: ${log.result}`}</div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InteractiveVoiceResponse;
